"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.defaultFgpPopTranslate = void 0;
exports.defaultFgpPopTranslate = {
    title: 'We\'re Excited',
    caption: 'OKAY.com is a Founding Member of Forbes Global Properties and the exclusive member in Hong Kong.',
    ptitleHtml: 'OKAY.com is proud to announce that we are a <br /><span class="c-fgppop__strong">Founding Member of Forbes Global Properties</span><br />and the exclusive member in Hong Kong',
    readMore: 'Read More',
};
